import { t } from "@travily/i18n";
import { Icon } from "@ui/components/Icon/Icon";
import type { WhereSuggestion } from "../types";

// The region ids are the Travily region slugs and must stay in step with
// REGION_SLUGS in apps/main/app/frontend/lib/where-regions.ts — product-ui
// cannot import from the app, so the coupling is by convention.
export function getDefaultWhereSuggestions(): WhereSuggestion[] {
  return [
    { id: "nearby", name: t("components.search_bar.nearby"), icon: <Icon name="location" type="sticker" /> },
    {
      id: "north-america",
      name: t("components.search_bar.region_north_america"),
      icon: <Icon name="map" type="sticker" />,
    },
    {
      id: "latin-america",
      name: t("components.search_bar.region_latin_america"),
      icon: <Icon name="map" type="sticker" />,
    },
    {
      id: "caribbean",
      name: t("components.search_bar.region_caribbean"),
      icon: <Icon name="map" type="sticker" />,
    },
    {
      id: "europe",
      name: t("components.search_bar.region_europe"),
      icon: <Icon name="map" type="sticker" />,
    },
    {
      id: "africa",
      name: t("components.search_bar.region_africa"),
      icon: <Icon name="map" type="sticker" />,
    },
    {
      id: "middle-east",
      name: t("components.search_bar.region_middle_east"),
      icon: <Icon name="map" type="sticker" />,
    },
    {
      id: "asia",
      name: t("components.search_bar.region_asia"),
      icon: <Icon name="map" type="sticker" />,
    },
    {
      id: "oceania",
      name: t("components.search_bar.region_oceania"),
      icon: <Icon name="map" type="sticker" />,
    },
  ];
}
